<ul class="list-disc list-inside ml-2 p-sm flex flex-col gap-4">
	<li>Validate {{ possessiveAdjective }} account</li>
	<li>Add {{ possessiveAdjective }} digital signature</li>
	<li>Create a security PIN</li>
	<li>Route instructions to {{ possessiveAdjective }} fax number</li>
</ul>
